<template>
  <div class="evaluation-prize-edit">
    <el-card class="evaluation-prize-main">
      <div slot="header">
        <el-page-header @back="$router.push('/evaluation')" content="奖项设置"></el-page-header>
      </div>
      <el-form ref="form" :model="form">
        <el-row>
          <el-col v-for="(item, index) in prize" :key="index" class="card-col">
            <el-card :body-style="{ padding: '10px' }" class="card-item">
              <div slot="header">
                <span>奖项{{index+1}}</span>
                <el-button type="text" @click="deletePrize(index,item)">删除</el-button>
              </div>
              <div>
                <el-input v-model="item.name" placeholder="奖项名称"></el-input>
                <template v-for="describe in Object.keys(describeOptions)">
                  <el-input v-model="item[describe]" type="textarea" :placeholder="describeOptions[describe]" rows="5" :key="describe"></el-input>
                </template>
                <el-input v-model="item.describe" type="textarea" placeholder="评选标准" rows="5"></el-input>
                <el-input v-model="item.number" placeholder="中奖人数（非必填）"></el-input>
              </div>
              <div class="tr">
                  <el-button type="primary" @click="submitPrize(item,index)" :loading="loading[index]">提交</el-button>
              </div>
            </el-card>
          </el-col>
            <el-col class="card-col">
            <el-card :body-style="{ padding: '10px' }" class="add-card" @click.native="addPerson">
              <div>
                <i class="el-icon-plus"></i>
                <div>新增奖项</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
          <!-- <div>
              <el-button type="primary" @click="submitPrize" :loading="loading">提交</el-button>
              <el-button @click="$router.push('/changjing?active=1')">取消</el-button>
          </div> -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
const prizeInit = {
  name: '',
  describe: '',
  number: ''
}
export default {
  data() {
    return {
      loading: [false],
      prize: [this.$utils.cloneDeep(prizeInit)],
      id: '',
      form: {},
      nameOptions: [],
      detail: {},
      describeOptions: {
        describe: '奖项意义',
        describe2: '评选标准',
        describe3: '评选方式'
      }
    }
  },
  computed: {
    creatable() { return +this.$route.params.id === 0 }
  },

  methods: {
    deletePrize(index, item) {
      this.$_confirm({
        name: '删除',
        operate: () =>
          this.$http.post('/activity/delete', {
            id: item.id
          }).then(() => {
            if (this.prize && this.prize.length === 0) {
              this.prize = [this.$utils.cloneDeep(prizeInit)]
            } else {
              this.prize.splice(index, 1)
            }
          })
      })
    },
    addPerson() {
      this.prize.push(this.$utils.cloneDeep(prizeInit))
    },
    submitPrize(item, index) {
      let params = JSON.parse(JSON.stringify(item))
      this.$set(this.loading, index, true)
      if (!params.name && !params.describe && params.id) {
        // this.$http.post('/corpmessage/delete', {
        //   system: 'changjing',
        //   id: this.id
        // })
      } else if (!params.name && !params.describe) {
        return
      }
      // params = JSON.stringify(params)
      this.$http.post(params.id ? '/activity/change' : '/activity/add', params).then(res => {
        if (res.successful) {
          item.id = res.data.id
        }
        this.$set(this.loading, index, false)
      })
    }
  },
  created() {
    this.$http.post('/activity/list').then(res => {
      res.data.data.length && (this.prize = res.data.data) && (this.loading = res.data.data.map(() => { return false }))
    })
  }
}
</script>

<style lang="scss">
.evaluation-prize-edit {
  .el-page-header{
    border-bottom:none;
  }
  .add-card{
    padding: 10px;
    height: 302px;
    display: flex;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #999;
    text-align:center;
    i{
      font-size: 34px;
      padding-bottom:10px;
    }
  }
  .el-card__header > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tr{
    text-align:right;
    margin-top: 10px;
  }
  .evaluation-prize-main{
    >.el-card__body{
      padding-right:0;
    }
    .card-item{
      .el-input,
      .el-textarea{
        width:100%;
        margin-bottom:5px;
      }
      .el-card__header .el-button--text{
        padding:0;
      }
    }
    .card-col{
      width:300px;
      margin-right:20px;
      margin-bottom:20px;
      .el-input--small .el-input__inner,
      .el-textarea__inner {
          // border: none;
          // border-bottom: 1px solid #DCDFE6;
          // border-radius: 0;
          // padding: 5px;
          // resize: none;
          // border: none;
          border-radius: 0;
          padding: 5px;
          resize: none;
          background: #fafafa;
          border-color: #e8e8e8;
          border-radius: 4px;
      }
    }
  }
}
</style>
